import Vue from 'vue'
import { Popover } from 'element-ui'
import deleteIcon from './images/delete.png'
import './index.less'
import { isErpElSelectRemote } from './utils'

let timer

function createPopover(options) {
  const PopoverConstructor = Vue.extend({
    data() {
      return {
        historyKeywords: [],
        historyKeywordClickCallback: null,
        historyKeywordDeleteCallback: null,
        historyKeywordDeleteAllCallback: null,
        parentWidth: 0,
      }
    },
    render(h) {
      const { historyKeywords, parentWidth } = this

      const renderHistoryItem = (item, index) => h('div',
        {
          class: 'erp-autocomplete',
          on: {
            click: (event) => {
              if (event.target.tagName === 'IMG') return
              this.historyKeywordClick(item, index)
            }
          },
        },
        [
          h('div', {
            class: 'erp-autocomplete-historyKeyword',
            attrs: {
              title: item.value
            }
          }, item.value),
          h('img', {
            class: 'erp-autocomplete-deleteIcon',
            attrs: {
              src: deleteIcon
            },
            on: {
              click: (event) => {
                if (event.target !== event.currentTarget) return
                this.historyKeywords.splice(index, 1)
                this.historyKeywordDelete(item)
                this.setPopover(!!this.historyKeywords.length, 'documentClick')
              }
            },
          })
        ])

      const renderHistoryItems = historyKeywords.map(renderHistoryItem)

      return h(options.popoverComponent, {
        ref: 'popoverRef',
        props: {
          popperClass: 'erp-autocomplete_popover',
          // transition: '',
          visibleArrow: false,
          trigger: 'manual',
        },
        scopedSlots: {
          default: () => h('div', {
            class: 'erp-autocomplete-content',
            style: {
              width: parentWidth
            }
          }, [
            h('div', {
              class: 'erp-autocomplete-title',
            }, [
              '历史输入',
              h('img', {
                attrs: {
                  src: deleteIcon,
                  title: '删除全部',
                },
                on: {
                  click: () => {
                    this.historyKeywords = []
                    this.historyKeywordDeleteAll()
                  }
                }
              })
            ]),
            ...renderHistoryItems
          ])
        },
      })
    },
    methods: {
      show(el) {
        if (!el) return
        let parentWidth = el.getBoundingClientRect().width
        // el-select特殊处理
        if (isErpElSelectRemote(el)) {
          const elSelect = el.parentNode.parentNode
          if (elSelect) {
            parentWidth = elSelect.getBoundingClientRect().width
            el = elSelect
          }
        }
        // 最小值的判断
        parentWidth = Math.max(parentWidth, 90)

        this.parentWidth = parentWidth + 'px'
        this.$refs.popoverRef.referenceElm = el
        this.$refs.popoverRef.createPopper()
        this.$refs.popoverRef.updatePopper()
        this.setPopover()
      },
      setPopover(status = true, eventName) {
        if (status && this.historyKeywords.length === 0) {
          return
        }
        this.$refs.popoverRef.showPopper = status
        if (status && eventName) {
          clearTimeout(timer)
          timer = setTimeout(() => {
            document.addEventListener('click', this.documentClick, { once: true })
          }, 100)
        }
      },
      hide() {
        this.setPopover(false)
      },
      setData(list) {
        this.historyKeywords = list
      },
      documentClick() {
        this.setPopover(false)
      },
      historyKeywordClick(i, index) {
        this.historyKeywordClickCallback && this.historyKeywordClickCallback(i, index)
      },
      historyKeywordDelete(i) {
        this.historyKeywordDeleteCallback && this.historyKeywordDeleteCallback(i)
      },
      historyKeywordDeleteAll(i) {
        this.historyKeywordDeleteAllCallback && this.historyKeywordDeleteAllCallback(i)
      }
    }
  })

  // 创建Popover实例
  const popover = new PopoverConstructor({
    propsData: {
      ...options.props,
    },
  })
  popover.$mount()
  const popoverElement = popover.$el
  document.body.appendChild(popoverElement)
  return {
    popover
  }
}

const popoverOptions = {
  popoverComponent: Popover
}
const { popover } = createPopover(popoverOptions)

export function setPopoverData(el, options) {
  if (!el) return
  const { historyKeywords } = options
  if (historyKeywords && historyKeywords.length) {
    popover.setData(historyKeywords)
  }
  popover.historyKeywordClickCallback = options.historyKeywordClick
  popover.historyKeywordDeleteCallback = options.historyKeywordDelete
  popover.historyKeywordDeleteAllCallback = options.historyKeywordDeleteAll
  showPopover(el)
}

export function hidePopover() {
  popover.hide()
}

export function showPopover(el) {
  if (!el) return
  document.removeEventListener('click', popover.documentClick)
  popover.show(el)
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/popover.js